import React from "react";
import Swal from "sweetalert2";
import "../assets/css/contact_style.css";
import "../assets/css/Responsive/contact_responsive.css";

export default function Contactus() {
  document.title = "Sanvicasa - Contact Us";

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    formData.append("access_key", "a78b83a8-b888-402a-ab79-9aea7f73fbad"); // Replace with Web3Forms key

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const result = await response.json();

    if (result.success) {
      Swal.fire({
        icon: "success",
        title: "Message Sent!",
        text: "Thank you for contacting us. We’ll get back to you soon.",
        confirmButtonColor: "#3085d6",
      });
      e.target.reset(); // clear form
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong! Please try again later.",
        confirmButtonColor: "#d33",
      });
    }
  };

  return (
    <div>
      <div className="contact-container">
        <div className="contact-sec1" data-aos="fade-up">
          <div className="contact-back">
            <h1>Contact Us</h1>
            <p>
              Your dream home is just a conversation away. Reach out to us
              today, and let’s discuss how we can turn your ideas into reality.
            </p>
          </div>
        </div>
        <div className="contact-details" data-aos="fade-up">
          <div className="inner">
            <h1>Get in Touch</h1>
            <p>
              We’d love to hear from you. Whether you’re interested in our
              luxurious residences, have a question, or simply want to connect,
              our team is here to assist you every step of the way. Reach out to
              us and experience a seamless journey toward finding your dream
              home. Your inquiries are always welcome — let’s start the
              conversation and bring your vision to life.
            </p>
          </div>
        </div>
        <section className="contact-sec2">
          <div className="inner">
            <div className="left-inner" data-aos="fade-right">
              <div className="enq-details">
                <p>
                  Have queries or need assistance regarding Sanvicasa Group
                  products or services? We're here to help! Feel free to get in
                  touch with us for any inquiry, at
                  {/* <b>+91-9825788836</b> */}
                  <p>
                    <a href="tel:+919825788836">+91 9825788836</a> /
                    <a href="tel:+919825788837">37</a>
                  </p>
                </p>
              </div>
              <div className="addrs">
                <p>
                  Corporate Office Address <div className="long-bar"></div>
                </p>
                <p>'SANVICASA GROUP'</p>
                {/* <p>Safal Parisar Rd, South Bopal, Ahmedabad</p> */}
                <p>Sanvicasa-Saharsh</p>
                <p>Opp. Solis One,Near Samanvay Scintilla,</p>
                <p>South Bopal, Ahemdabad</p>
              </div>
              {/* <button>
                <i class="fa-solid fa-map-location-dot"></i>&nbsp;View on map
              </button> */}
              <button
                onClick={() =>
                  window.open(
                    "https://www.google.com/maps/place/Sanvicasa+Saharsh+-+2+%26+3+Bhk+at+South+bopal+best+location/@23.0150492,72.4590427,401m/data=!3m2!1e3!4b1!4m6!3m5!1s0x395e9b5d24035959:0xa371482e58c0e0ef!8m2!3d23.0150492!4d72.4590427!16s%2Fg%2F11w3h0cbfy?entry=ttu&g_ep=EgoyMDI1MDYwNC4wIKXMDSoASAFQAw%3D%3D",
                    "_blank"
                  )
                }
              >
                <i className="fa-solid fa-map-location-dot"></i>&nbsp;View on
                map
              </button>
            </div>
           
            <div className="right-inner" data-aos="fade-left">
              <form
                action="https://api.web3forms.com/submit"
                method="POST"
                onSubmit={handleSubmit}
              >
                {/* 🔑 Required: Your Access Key */}
                {/* <input
                  type="hidden"
                  name="access_key"
                  value="YOUR_ACCESS_KEY"
                /> */}

                <div className="name">
                  <input
                    type="text"
                    name="name"
                    id="nm"
                    placeholder="Name"
                    required
                  />
                </div>

                <div className="email">
                  <input
                    type="email"
                    name="email"
                    id="eml"
                    placeholder="Email"
                    required
                  />
                </div>

                <div className="number">
                  <input
                    type="number"
                    name="mob"
                    id="phone-no"
                    placeholder="Mobile Number"
                    required
                  />
                </div>

               
                <div className="department">
                  <select name="department" id="depart" required>
                    <option value="first">Select Department</option>
                    <option value="sales">Sales</option>
                    <option value="general_inquiry">General Inquiry</option>
                    <option value="customer_support">Customer Support</option>
                  </select>
                </div>

                <div className="comment">
                  <textarea
                    name="comment"
                    id="comnt"
                    rows={5}
                    cols={20}
                    placeholder="Comment"
                    required
                  ></textarea>
                </div>

                <button type="submit">Submit</button>
              </form>
            </div>
          </div>
        </section>
        <section className="contact-sec3">
          <div className="department" data-aos="fade-up">   
                      <p>
              Departments <div className="long-bar"></div>
            </p>
          </div>
          {/* <div className="others-dep" data-aos="fade-up">
            <h2>Other Departments</h2>
          </div> */}
          <div className="inner" data-aos="zoom-in" data-aos-delay="100">
            <div className="sales">
              <h3>Sales</h3>
              <p>
                <a href="tel:+919825788836">+91 9825788836</a> /
                <a href="tel:+919825788837">37</a>
              </p>
              <p>
                <a href="mailto:info@sanvicasagroup.in">
                  info@sanvicasagroup.in
                </a>
              </p>
            </div>

            <div className="support" data-aos="zoom-in" data-aos-delay="200">
              <h3>Customer Support</h3>
              <p>
                <a href="tel:+919825788836">+91 9825788836</a> /
                <a href="tel:+919825788837">37</a>
              </p>
              <p>
                <a href="mailto:info@sanvicasagroup.in">
                  info@sanvicasagroup.in
                </a>
              </p>
            </div>

            <div className="inquiry" data-aos="zoom-in" data-aos-delay="300">
              <h3>General Inquiry</h3>
              <p>
                <a href="tel:+919825788836">+91 9825788836</a> /
                <a href="tel:+919825788837">37</a>
              </p>
              <p>
                <a href="mailto:info@sanvicasagroup.in">
                  info@sanvicasagroup.in
                </a>
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
